import { createVanIconComponent } from "./van"

const Card = createVanIconComponent("card")
export default Card
